<template>
    <div>
<!--        <van-popover class="w-full" @close="onClosePopover" @open="onOpenPopover" v-model="popup" trigger="click"-->
<!--                     placement="bottom-start">-->
<!--            <van-checkbox-group v-model="issue.voteAnswer">-->
<!--                <ul class="select-group pt-2">-->
<!--                    <li v-for="item in items" :key="item.id" class="select-item">-->
<!--                        <div>-->
<!--                            <van-checkbox shape="square" :name="item.id">-->
<!--                                <span>{{ item.content.text }}</span>-->
<!--                                <template v-slot:icon="{ checked }">-->
<!--                                    <icon-checkbox :value="checked" />-->
<!--                                </template>-->
<!--                            </van-checkbox>-->
<!--                        </div>-->
<!--                    </li>-->
<!--                    <li v-if="!items.length && popup" class="select-item">-->
<!--                        <div>-->
<!--                            <span>暂无数据</span>-->
<!--                        </div>-->
<!--                    </li>-->
<!--                </ul>-->
<!--            </van-checkbox-group>-->
<!--            <template v-slot:reference>-->
<!--                <van-field-->
<!--                        class="w-full"-->
<!--                        readonly-->
<!--                        @click.stop="onFocus"-->
<!--                        placeholder="请选择"-->
<!--                        right-icon="arrow-down"-->
<!--                        v-model="inputValue"-->
<!--                />-->
<!--            </template>-->
<!--        </van-popover>-->
        <van-checkbox-group v-model="issue.voteAnswer">
            <ul class="select-group pt-2">
                <li v-for="item in items" :key="item.id" class="select-item">
                    <div>
                        <van-checkbox shape="square" :name="item.id">
                            <span>{{ item.content.text }}</span>
                            <template v-slot:icon="{ checked }">
                                <icon-checkbox :value="checked" />
                            </template>
                        </van-checkbox>
                    </div>
                </li>
                <li v-if="!items.length && popup" class="select-item">
                    <div>
                        <span>暂无数据</span>
                    </div>
                </li>
            </ul>
        </van-checkbox-group>
    </div>
</template>

<script>
import { questionType } from 'dygc'
import IconCheckbox from '../../components/base/IconCheckbox.vue'

export default {
  name: 'VoteChoiceSearch',
  components: { IconCheckbox },
  type: [questionType.SINGLE_CHOICE, questionType.MULTIPLE_CHOICE, questionType.SINGLE_SELECT, questionType.MULTIPLE_SELECT, questionType.IMAGE_CHOICE, questionType.IMAGE_MULTIPLE_CHOICE],
  props: {
    question: Object
  },
  data() {
    return {
      popup: false,
      inputValue: '',
      fieldValue: '',
    }
  },
  computed: {
    items() {
      return this.question.issue.items
    },
    issue() {
      return this.question.issue
    }
  },
  methods: {
    onOpenPopover() {
      this.inputValue = ''
    },
    onClosePopover() {
      this.inputValue = this.fieldValue
    },
    onFocus() {
      this.popup = !this.popup
    },
    resetField(list) {
      let items = this.items.filter(item => list.includes(item.id))
      this.fieldValue = items.map(item => item.content.text).join(',')
    }
  },
  mounted() {
    const val = this.issue.voteAnswer
    if (val.length) {
      this.resetField(val)
      this.inputValue = this.fieldValue
    }
  },
  watch: {
    'issue.voteAnswer'(val) {
      this.resetField(val)
    }
  }
}
</script>

<style scoped>
/*.van-popover {*/
/*    max-height: 30vh;*/
/*    overflow: auto;*/
/*    --webkit-overflow-scrolling: touch;*/
/*}*/

/*.van-checkbox-group {*/
/*    position: relative;*/
/*    --webkit-overflow-scrolling: touch*/
/*}*/

/*.select-group {*/
/*    position: relative;*/
/*    height: 28vh;*/
/*    box-sizing: border-box;*/
/*    overflow: auto;*/
/*    --webkit-overflow-scrolling: touch*/
/*}*/
</style>